export default {
    namespaced: true,
    state: {
        notifications: [],
    },
    mutations: {
        push(state, response) {
            if (response.error == "authentication failure") return;
            state.notifications.push(response);
        },
        raw(state, response) {
            if (response.error == "authentication failure") return;
            if (response.error) {
                response = { error: response.error };
                state.notifications.push(response);
            }
            if (response.status == "ok") {
                response = { success: "Success" };
                state.notifications.push(response);
            }
        },
        success(state, message) {
            state.notifications.push({ success: message });
        },
        error(state, message) {
            state.notifications.push({ error: message });
        },
        clearData(state, response) {
            state.notifications = [];
        },
    },
};
